import _ from 'lodash';
import { convertDuration } from '@/datetime/dateTime.utilities';
import { setConfigurationData, systemMessage } from '@/services/systemConfiguration.utilities';
import { sqTimezones } from '@/utilities/datetime.constants';
import { sqSystemApi } from '@seeqdev/api/endpoint/SystemApi';
import type { AxiosResponse } from 'axios';
import type { ServerStatusOutputV1 } from '@seeqdev/api/model/models';

export function fetchConfiguration() {
  return Promise.resolve(sqSystemApi.getServerStatus({ includeInternal: false })).then(
    ({ data }: AxiosResponse<ServerStatusOutputV1>) => {
      const updatedConfigurationOptions = _.transform(
        data.configurationOptions ?? [],
        (memo: Record<string, unknown>, { path, value }) => {
          memo[path as string] = value;
        },
        {},
      );
      const offset = data.timeZone?.split(' ')?.[1];

      setConfigurationData({
        ...data,
        configurationOptions: updatedConfigurationOptions,
        defaultMaxCapsuleDuration: convertDuration(data.defaultMaxCapsuleDuration),
        defaultMaxInterpolation: convertDuration(data.defaultMaxInterpolation),
        timeZone: sqTimezones.findMostCommonTimeZone(offset),
      });

      // Return server specs and system message for caller to update stores
      return {
        serverSpecs: data.serverSpecs,
        systemMessage: systemMessage(),
      };
    },
  );
}
